module.exports = __webpack_public_path__ + "img/swyl.f5e428a.png";